import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';

export interface SelectableBulletedItemProps {
  id: string;
  dataTestId?: string;
  selected: boolean;
  className?: string;
  children: ReactNode;
}

const SelectableBulletedItem: FC<SelectableBulletedItemProps> = ({ id, dataTestId = id, selected, className, children }) => {
  return (
    <Main className={className} id={id} data-testid={dataTestId} selected={selected}>
      {children}
    </Main>
  );
};

export default SelectableBulletedItem;

const Main = styled.div<{ selected: boolean }>`
  display: block;
  padding: 0.5rem 0.75rem;
  font-family: Inter, system-ui, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  color: #ffffff91;
  text-decoration: none;
  border-radius: 0.375rem;
  transition: background-color 150ms;
  cursor: pointer;

  background-color: ${(p): string => (p.selected ? '#FFFFFF12' : 'transparent')};

  &:hover {
    background-color: #ffffff12;
  }
`;
